<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-25
    	描述：组件-设置分佣
    -->
  <el-dialog title="商品设置" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" width="900px">
    <!--    <div class="common-seach-wrap">-->
    <!--      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">-->
    <!--        <el-form-item label="商品名称">-->
    <!--          <el-input placeholder="请输入商品名称" v-model="formInline.search"><el-button slot="append" icon="el-icon-search" @click="getData">查询</el-button></el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--    </div>-->

    <!--内容-->
    <div class="product-content">
      <div class="common-form">分佣设置</div>
      <el-form size="small" ref="form" :model="form" label-width="180px">
        <el-form-item label="商品名称：" class="product_el_form_label_name">
          <div class="d-s-c">
            <span class="ml10 f14">{{ productInfo.productName }}</span>
          </div>
        </el-form-item>

        <el-form-item label="开启分销：">
          <el-radio-group v-model="form.model.isEnableCommission">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="佣金类型：" v-if="form.model.isEnableCommission==1">
          <el-radio-group v-model="form.model.commissionType" @change="changeAgentMoneyType">
            <el-radio :label="10">百分比</el-radio>
            <el-radio :label="20">固定金额</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="" v-if="form.model.isEnableCommission==1" label="佣金设置："
                      :rules="[{ required: true, message: ' ' }]" prop="model.commissionMoney">
          <div class="max-w460">

            <!--          <el-input type="number" min="0" v-model="form.model.maxPointsDiscount" class="max-w460"></el-input>-->

            <!--        <el-table :data="form.gradeList" border size="mini" style="width: 100%">-->
            <!--          <el-table-column prop="name" label="会员等级">-->
            <!--          </el-table-column>-->
            <!--          <el-table-column prop="name" label="折扣">-->
            <!--            <template v-slot="scope">-->
            <div class="d-s-c">
              <el-input v-model="form.model.commissionMoney" type="number" placeholder="请输入佣金"
                        style="width: 35%;"></el-input>
              <span class="ml10">{{ agentUnit }}</span>
            </div>
            <!--            </template>-->
            <!--          </el-table-column>-->
            <!--        </el-table>-->
          </div>
        </el-form-item>

        <div class="common-form">销售方式设置</div>
        <el-form-item label="商品销售方式：">
          <el-radio-group v-model="form.model.isPresell">
            <el-radio :label="0">现售商品</el-radio>
            <el-radio :label="1">预售商品</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="预售起止时间：" :rules="[{ required: true, message: '设置预售起止时间' }]"
                      prop="model.presellStartTime" v-if="form.model.isPresell==1">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="presellTime"
              type="datetimerange"
              value-format="yyyy-MM-dd hh:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="预计到货时间：" :rules="[{ required: true, message: '设置预计到货时间' }]"
                      prop="model.arrivalTime" v-if="form.model.isPresell==1">
          <div class="d-s-c">
            <el-input-number v-model="form.model.arrivalTime" @change="handleArrivalTimeChange" :min="1"
                             label=""></el-input-number>
            <span class="ml10">天</span>
          </div>
        </el-form-item>

        <div class="common-form">配送方式设置</div>
        <el-form-item label="配送方式：">
          <el-radio-group v-model="form.model.deliveryType">
            <el-radio v-for="(item,index) in all_type" :label="item.value" :key="index">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="addClerk">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PorductApi from '@/api/product.js'

export default {
  name: 'settingAgent',
  data () {
    return {
      /*是否显示*/
      dialogVisible: false,
      /*结果类别*/
      type: 'error',
      /*传出去的参数*/
      params: null,
      agentUnit: '%',
      all_type: [{
        name: '快递',
        value: 10
      }, {
        name: '自提',
        value: 20
      }],
      form: {
        model: {
          isEnableCommission: 1,
          commissionType: 10,
          commissionMoney: '',
          deliveryType: 10,
          presellStartTime: '',
          presellEndTime: '',
          arrivalTime: 0,
          /*是否预售*/
          isPresell: 0,
        }
      }
    }
  },
  props: ['isShowAgent', 'productId', 'shopSupplierId', 'productInfo'],
  watch: {
    isShowAgent: function (n, o) {
      if (n != o) {
        if (n) {
          this.dialogVisible = n
          this.type = 'error'
          this.params = null
          this.getData()
        }
      }
    }
  },
  computed: {
    presellTime: {
      get () {

        return [this.form.model.presellStartTime || '', this.form.model.presellEndTime || '']
      },
      set (e) {
        if (e && e.length > 1) {
          this.form.model.presellStartTime = e[0] || ''
          this.form.model.presellEndTime = e[1] || ''
        } else {
          this.form.model.presellStartTime = ''
          this.form.model.presellEndTime = ''
        }
      }
    }
  },
  created () {

  },
  methods: {


    handleArrivalTimeChange (e) {
      console.log('handleArrivalTimeChange = ' + e)
      if (e === undefined) {
        this.$nextTick(() => {
          this.form.model.arrivalTime = 1
        })


      }
    },
    getData () {
      let self = this
      PorductApi.getSupplierProductData(
        {
          productId: self.productId,
        },
        true
      )
        .then(res => {
          self.loading = false

          Object.assign(self.form, res.data)

          if (self.form.model.commissionType == '20') {
            this.agentUnit = '元'
          }

        })
        .catch(error => {
          self.loading = false
          console.log(error)
        })
    },

    //点击确定
    addClerk () {
      let self = this
      let params = {}
      self.$refs.form.validate(valid => {
        if (valid) {
          PorductApi.editSupplierProductData(self.form.model, true)
            .then(data => {
              self.params = params
              self.type = 'success'
              self.dialogVisible = false
            })

        } else {
          self.$message({
            message: '请检查必填项是否填写完整',
            type: 'error'
          })
        }

      })

    },

    /*关闭弹窗*/
    dialogFormVisible () {

      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      })
    },
    /*换算分销佣金单位*/
    changeAgentMoneyType (val) {
      if (val == '10') {
        this.agentUnit = '%'
      } else {
        this.agentUnit = '元'
      }
    },

  }
}
</script>

<style>
.product_el_form_label_name >>> .el-form-item__label {
  font-size: 16px !important;

}

</style>




// WEBPACK FOOTER //
// src/views/supplier/supplier/product/edit.vue